// Google Places 地址联想：与 Location.vue 使用同一套 @googlemaps/js-api-loader + Places 服务，
// 抽成共享工具供设备详情飞出等处复用（集中 apiKey，避免多处硬编码漂移）。
import { Loader } from "@googlemaps/js-api-loader";

// 与 Location.vue 现用一致的 key（后端已替换为用户自有 key）
const GOOGLE_MAPS_KEY = "AIzaSyA1Rd3GCCRnoZU1dmTRgFZoRaLcsq13BOw";

let loaderPromise = null;
function loadGoogle() {
  if (!loaderPromise) {
    const loader = new Loader({ apiKey: GOOGLE_MAPS_KEY, version: "weekly", libraries: ["places"] });
    loaderPromise = loader.load();
  }
  return loaderPromise;
}

// 输入关键字 → 返回联想地址（含 formatted_address 与经纬度）。失败/无结果返回 []。
export function queryPlaces(queryString) {
  const input = String(queryString || "").trim();
  if (!input) {
    return Promise.resolve([]);
  }
  return loadGoogle()
    .then(google => {
      const autocompleteService = new google.maps.places.AutocompleteService();
      const placesService = new google.maps.places.PlacesService(document.createElement("div"));
      return new Promise(resolve => {
        autocompleteService.getPlacePredictions({ input, types: ["establishment", "geocode"] }, (predictions, status) => {
          if (status !== google.maps.places.PlacesServiceStatus.OK || !predictions) {
            resolve([]);
            return;
          }
          const details = predictions.slice(0, 6).map(prediction => {
            return new Promise(res => {
              placesService.getDetails(
                { placeId: prediction.place_id, fields: ["name", "formatted_address", "address_components", "geometry"] },
                (place, st) => {
                  if (st === google.maps.places.PlacesServiceStatus.OK && place) {
                    let county = "";
                    let lat = "";
                    let lng = "";
                    if (place.address_components) {
                      const c = place.address_components.find(comp => comp.types.includes("administrative_area_level_2"));
                      if (c) {
                        county = c.long_name.replace(/\s*County$/i, "").trim();
                      }
                    }
                    if (place.geometry && place.geometry.location) {
                      lat = place.geometry.location.lat();
                      lng = place.geometry.location.lng();
                    }
                    res({ name: place.name, address: place.formatted_address, county, lat, lng });
                  } else {
                    res({
                      name: prediction.structured_formatting.main_text,
                      address: prediction.structured_formatting.secondary_text || prediction.description,
                      county: "",
                      lat: "",
                      lng: ""
                    });
                  }
                }
              );
            });
          });
          Promise.all(details).then(resolve);
        });
      });
    })
    .catch(() => []);
}

export default { queryPlaces };
